import Swiper from 'swiper';
import {Autoplay} from 'swiper/modules'

const initVideoBanner = () => {
	const components = document.querySelectorAll( 'section.cds2-video-banner' );

	if ( !components.length )
	{
		return;
	}

	const onVideoHover = ( slide ) => {
		slide.addEventListener( 'mouseenter', () => {
			const video = slide.querySelector( 'div.video > video' );
			
			if ( video )
			{	
				video.pause();
			}
		}, true );

		slide.addEventListener( 'mouseleave', () => {
			const video = slide.querySelector( 'div.video > video' );

			if ( video )
			{	
				video.play();
			}
		}, true );
}

	Array.from( components ).forEach( ( it ) => {
		const slider = new Swiper( 'div.swiper-video-banner', {
			direction: 'horizontal',
			slidesPerView: 'auto',
			modules: [Autoplay],
			autoplay: {
				enabled: false,
			},
			breakpoints: {
				1024: {
					centeredSlides: true,
					direction: 'vertical',
					loop: true,
					autoplay: {
						enabled: true,
						delay: 7000,
					},
				}
			}
		} );

		slider.on( 'slideChangeTransitionEnd', () => {
			const activeSlide = it.querySelector( '.swiper-slide-active' );

			if ( activeSlide )
			{
				onVideoHover( activeSlide );
			}
		} );

		const activeSlide = it.querySelector( '.swiper-slide-active' );

		if ( activeSlide )
		{
			onVideoHover( activeSlide );
		}
	} );

};

export {
	initVideoBanner,
}
